// src/components/Callback.jsx

import React, { useEffect, useState } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

import { Spinner, Alert, Container, Button } from 'react-bootstrap';

import { handleAuthentication } from '../services/authService';


const Callback = ({ onAuthSuccess }) => {

  const navigate = useNavigate();

  const location = useLocation();

  const [error, setError] = useState(null);

  const [processing, setProcessing] = useState(true);

  

  useEffect(() => {

    const processAuth = async () => {

      try {

        // Log current URL for debugging

        console.log("Callback component loaded. Current URL:", window.location.href);

        

        // Parse the URL for the authorization code

        const params = new URLSearchParams(location.search);

        const code = params.get('code');

        

        if (!code) {

          console.error("No authorization code found in URL");

          setError('No authorization code found. Authentication failed.');

          setProcessing(false);

          return;

        }

        

        console.log("Authorization code received, length:", code.length);

        

        // Process the authentication

        await handleAuthentication(code);

        

        console.log("Authentication successful, preparing to redirect");

        

        // Notify parent component about successful auth

        if (onAuthSuccess) {

          onAuthSuccess();

        }

        

        // Check if there was a pending redirect before login

        const redirectPath = localStorage.getItem('auth_redirect_path') || '/';

        localStorage.removeItem('auth_redirect_path');

        

        console.log("Redirecting to:", redirectPath);

        

        // Redirect to the home page or saved redirect

        setProcessing(false);

        navigate(redirectPath);

      } catch (err) {

        console.error('Authentication error in callback:', err);

        setError(err.message || 'Failed to authenticate. Please try again.');

        setProcessing(false);

      }

    };

    

    processAuth();

  }, [location, navigate, onAuthSuccess]);

  

  // Display a loading spinner or error message

  return (

    <Container className="d-flex justify-content-center align-items-center flex-column" style={{ minHeight: '60vh' }}>

      {processing ? (

        <div className="text-center">

          <Spinner animation="border" role="status" size="lg" />

          <p className="mt-3 lead">Processing authentication, please wait...</p>

          <small className="text-muted">Callback URL: {window.location.href}</small>

        </div>

      ) : error ? (

        <Alert variant="danger" className="w-100 max-w-md">

          <Alert.Heading>Authentication Error</Alert.Heading>

          <p>{error}</p>

          <hr />

          <div className="d-flex justify-content-between">

            <Button variant="outline-danger" onClick={() => navigate('/')}>Return to Login</Button>

            <Button variant="primary" onClick={() => window.location.reload()}>Try Again</Button>

          </div>

        </Alert>

      ) : (

        <div className="text-center">

          <Spinner animation="border" role="status" />

          <p className="mt-3">Authentication successful. Redirecting...</p>

        </div>

      )}

    </Container>

  );

};


export default Callback;
